/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Misc_Androidbeta_Steps_Added1Inputs */

const id_misc_androidbeta_steps_added1 = /** @type {(inputs: Misc_Androidbeta_Steps_Added1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anda akan ditambahkan secara manual ke jalur pengujian tertutup dalam beberapa jam`)
};

const ms_misc_androidbeta_steps_added1 = /** @type {(inputs: Misc_Androidbeta_Steps_Added1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anda akan ditambah secara manual ke trek ujian tertutup dalam beberapa jam`)
};

const da_misc_androidbeta_steps_added1 = /** @type {(inputs: Misc_Androidbeta_Steps_Added1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du vil blive manuelt tilføjet til det lukkede testspor inden for et par timer`)
};

const de_misc_androidbeta_steps_added1 = /** @type {(inputs: Misc_Androidbeta_Steps_Added1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sie werden innerhalb weniger Stunden manuell zum geschlossenen Test-Track hinzugefügt`)
};

const en_us2_misc_androidbeta_steps_added1 = /** @type {(inputs: Misc_Androidbeta_Steps_Added1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You will be manually added to the closed testing track within a few hours`)
};

const es_es2_misc_androidbeta_steps_added1 = /** @type {(inputs: Misc_Androidbeta_Steps_Added1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se te añadirá manualmente a la pista de pruebas cerradas en unas horas`)
};

const es_mx2_misc_androidbeta_steps_added1 = /** @type {(inputs: Misc_Androidbeta_Steps_Added1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Serás agregado manualmente a la pista de pruebas cerradas en unas horas`)
};

const fil_misc_androidbeta_steps_added1 = /** @type {(inputs: Misc_Androidbeta_Steps_Added1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ikaw ay manu-manong idadagdag sa closed testing track sa loob ng ilang oras`)
};

const fr_misc_androidbeta_steps_added1 = /** @type {(inputs: Misc_Androidbeta_Steps_Added1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vous serez ajouté manuellement au programme de test fermé dans quelques heures`)
};

const it_misc_androidbeta_steps_added1 = /** @type {(inputs: Misc_Androidbeta_Steps_Added1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verrai aggiunto manualmente al tracciato di test chiuso entro poche ore`)
};

const hu_misc_androidbeta_steps_added1 = /** @type {(inputs: Misc_Androidbeta_Steps_Added1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kézzel hozzáadunk a zárt tesztelési pályához néhány órán belül`)
};

const nl_misc_androidbeta_steps_added1 = /** @type {(inputs: Misc_Androidbeta_Steps_Added1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Je wordt binnen enkele uren handmatig toegevoegd aan het gesloten testspoor`)
};

const no_misc_androidbeta_steps_added1 = /** @type {(inputs: Misc_Androidbeta_Steps_Added1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du vil bli manuelt lagt til i det lukkede testsporet i løpet av noen timer`)
};

const pl_misc_androidbeta_steps_added1 = /** @type {(inputs: Misc_Androidbeta_Steps_Added1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zostaniesz ręcznie dodany do zamkniętego toru testowego w ciągu kilku godzin`)
};

const pt_br2_misc_androidbeta_steps_added1 = /** @type {(inputs: Misc_Androidbeta_Steps_Added1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Você será adicionado manualmente à faixa de testes fechada dentro de algumas horas`)
};

const pt_misc_androidbeta_steps_added1 = /** @type {(inputs: Misc_Androidbeta_Steps_Added1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Será adicionado manualmente ao percurso de testes fechados dentro de algumas horas`)
};

const ro_misc_androidbeta_steps_added1 = /** @type {(inputs: Misc_Androidbeta_Steps_Added1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vei fi adăugat manual la circuitul de testare închis în câteva ore`)
};

const fi_misc_androidbeta_steps_added1 = /** @type {(inputs: Misc_Androidbeta_Steps_Added1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sinut lisätään manuaalisesti suljettuun testausraiteeseen muutaman tunnin kuluessa`)
};

const sv_misc_androidbeta_steps_added1 = /** @type {(inputs: Misc_Androidbeta_Steps_Added1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du kommer att läggas till manuellt i det slutna testspåret inom några timmar`)
};

const vi_misc_androidbeta_steps_added1 = /** @type {(inputs: Misc_Androidbeta_Steps_Added1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bạn sẽ được thêm thủ công vào danh sách thử nghiệm kín trong vòng vài giờ`)
};

const tr_misc_androidbeta_steps_added1 = /** @type {(inputs: Misc_Androidbeta_Steps_Added1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Birkaç saat içinde kapalı test parkuruna manuel olarak ekleneceksiniz`)
};

const cs_misc_androidbeta_steps_added1 = /** @type {(inputs: Misc_Androidbeta_Steps_Added1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Během několika hodin budete ručně přidáni do uzavřené testovací větve`)
};

const bg_misc_androidbeta_steps_added1 = /** @type {(inputs: Misc_Androidbeta_Steps_Added1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ще бъдете ръчно добавени към затворената тестова следа в рамките на няколко часа`)
};

const ru_misc_androidbeta_steps_added1 = /** @type {(inputs: Misc_Androidbeta_Steps_Added1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вы будете вручную добавлены в закрытый тестовый трек в течение нескольких часов`)
};

const uk_misc_androidbeta_steps_added1 = /** @type {(inputs: Misc_Androidbeta_Steps_Added1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вас буде додано до закритого тестування протягом кількох годин`)
};

const ar_misc_androidbeta_steps_added1 = /** @type {(inputs: Misc_Androidbeta_Steps_Added1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ستتم إضافتك يدويًا إلى مسار الاختبار المغلق في غضون ساعات قليلة`)
};

const hi_misc_androidbeta_steps_added1 = /** @type {(inputs: Misc_Androidbeta_Steps_Added1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कुछ घंटों में जोड़ दिया जाएगा`)
};

const th_misc_androidbeta_steps_added1 = /** @type {(inputs: Misc_Androidbeta_Steps_Added1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`คุณจะถูกเพิ่มด้วยตนเองไปยังแทร็กการทดสอบแบบปิดภายในไม่กี่ชั่วโมง`)
};

const ja_misc_androidbeta_steps_added1 = /** @type {(inputs: Misc_Androidbeta_Steps_Added1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`数時間以内にクローズドテストトラックに手動で追加されます`)
};

const zh_cn2_misc_androidbeta_steps_added1 = /** @type {(inputs: Misc_Androidbeta_Steps_Added1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`您将在几小时内被手动添加到封闭测试轨道`)
};

const zh_hant1_misc_androidbeta_steps_added1 = /** @type {(inputs: Misc_Androidbeta_Steps_Added1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`您將在幾小時內被手動新增到封閉測試軌道`)
};

const ko_misc_androidbeta_steps_added1 = /** @type {(inputs: Misc_Androidbeta_Steps_Added1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`몇 시간 내에 클로즈드 테스트 트랙에 수동으로 추가됩니다`)
};

/**
* | output |
* | --- |
* | "You will be manually added to the closed testing track within a few hours" |
*
* @param {Misc_Androidbeta_Steps_Added1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const misc_androidbeta_steps_added1 = /** @type {((inputs?: Misc_Androidbeta_Steps_Added1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Misc_Androidbeta_Steps_Added1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_misc_androidbeta_steps_added1(inputs)
	if (locale === "ms") return ms_misc_androidbeta_steps_added1(inputs)
	if (locale === "da") return da_misc_androidbeta_steps_added1(inputs)
	if (locale === "de") return de_misc_androidbeta_steps_added1(inputs)
	if (locale === "en-US") return en_us2_misc_androidbeta_steps_added1(inputs)
	if (locale === "es-ES") return es_es2_misc_androidbeta_steps_added1(inputs)
	if (locale === "es-MX") return es_mx2_misc_androidbeta_steps_added1(inputs)
	if (locale === "fil") return fil_misc_androidbeta_steps_added1(inputs)
	if (locale === "fr") return fr_misc_androidbeta_steps_added1(inputs)
	if (locale === "it") return it_misc_androidbeta_steps_added1(inputs)
	if (locale === "hu") return hu_misc_androidbeta_steps_added1(inputs)
	if (locale === "nl") return nl_misc_androidbeta_steps_added1(inputs)
	if (locale === "no") return no_misc_androidbeta_steps_added1(inputs)
	if (locale === "pl") return pl_misc_androidbeta_steps_added1(inputs)
	if (locale === "pt-BR") return pt_br2_misc_androidbeta_steps_added1(inputs)
	if (locale === "pt") return pt_misc_androidbeta_steps_added1(inputs)
	if (locale === "ro") return ro_misc_androidbeta_steps_added1(inputs)
	if (locale === "fi") return fi_misc_androidbeta_steps_added1(inputs)
	if (locale === "sv") return sv_misc_androidbeta_steps_added1(inputs)
	if (locale === "vi") return vi_misc_androidbeta_steps_added1(inputs)
	if (locale === "tr") return tr_misc_androidbeta_steps_added1(inputs)
	if (locale === "cs") return cs_misc_androidbeta_steps_added1(inputs)
	if (locale === "bg") return bg_misc_androidbeta_steps_added1(inputs)
	if (locale === "ru") return ru_misc_androidbeta_steps_added1(inputs)
	if (locale === "uk") return uk_misc_androidbeta_steps_added1(inputs)
	if (locale === "ar") return ar_misc_androidbeta_steps_added1(inputs)
	if (locale === "hi") return hi_misc_androidbeta_steps_added1(inputs)
	if (locale === "th") return th_misc_androidbeta_steps_added1(inputs)
	if (locale === "ja") return ja_misc_androidbeta_steps_added1(inputs)
	if (locale === "zh-CN") return zh_cn2_misc_androidbeta_steps_added1(inputs)
	if (locale === "zh-Hant") return zh_hant1_misc_androidbeta_steps_added1(inputs)
	return ko_misc_androidbeta_steps_added1(inputs)
});
export { misc_androidbeta_steps_added1 as "misc.androidBeta.steps.added" }